/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRiskEvalReviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRiskEvalReviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRiskEvalReviewSecurity = {
  option1?: DeleteRiskEvalReviewSecurityOption1 | undefined;
  option2?: DeleteRiskEvalReviewSecurityOption2 | undefined;
};

export type DeleteRiskEvalReviewRequest = {
  /**
   * The policy the verdict belongs to.
   */
  policyId: string;
  /**
   * The chat session whose verdict to clear.
   */
  chatId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRiskEvalReviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRiskEvalReviewSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteRiskEvalReviewSecurityOption1$Outbound,
  DeleteRiskEvalReviewSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteRiskEvalReviewSecurityOption1ToJSON(
  deleteRiskEvalReviewSecurityOption1: DeleteRiskEvalReviewSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRiskEvalReviewSecurityOption1$outboundSchema.parse(
      deleteRiskEvalReviewSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRiskEvalReviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRiskEvalReviewSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteRiskEvalReviewSecurityOption2$Outbound,
  DeleteRiskEvalReviewSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteRiskEvalReviewSecurityOption2ToJSON(
  deleteRiskEvalReviewSecurityOption2: DeleteRiskEvalReviewSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRiskEvalReviewSecurityOption2$outboundSchema.parse(
      deleteRiskEvalReviewSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRiskEvalReviewSecurity$Outbound = {
  Option1?: DeleteRiskEvalReviewSecurityOption1$Outbound | undefined;
  Option2?: DeleteRiskEvalReviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRiskEvalReviewSecurity$outboundSchema: z.ZodMiniType<
  DeleteRiskEvalReviewSecurity$Outbound,
  DeleteRiskEvalReviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRiskEvalReviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRiskEvalReviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRiskEvalReviewSecurityToJSON(
  deleteRiskEvalReviewSecurity: DeleteRiskEvalReviewSecurity,
): string {
  return JSON.stringify(
    DeleteRiskEvalReviewSecurity$outboundSchema.parse(
      deleteRiskEvalReviewSecurity,
    ),
  );
}

/** @internal */
export type DeleteRiskEvalReviewRequest$Outbound = {
  policy_id: string;
  chat_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRiskEvalReviewRequest$outboundSchema: z.ZodMiniType<
  DeleteRiskEvalReviewRequest$Outbound,
  DeleteRiskEvalReviewRequest
> = z.pipe(
  z.object({
    policyId: z.string(),
    chatId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyId: "policy_id",
      chatId: "chat_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRiskEvalReviewRequestToJSON(
  deleteRiskEvalReviewRequest: DeleteRiskEvalReviewRequest,
): string {
  return JSON.stringify(
    DeleteRiskEvalReviewRequest$outboundSchema.parse(
      deleteRiskEvalReviewRequest,
    ),
  );
}
